<!--
  Esta es la plantilla que se usa para las páginas que pertenecen al panel
-->
<template>
  <v-main v-if="$store.operador.atributosRol" class="fondo-app">

    <!-- menu lateral / drawer -->

    <v-navigation-drawer v-model="menuLateral" fixed app >
      <v-list-item>
        <v-list-item-avatar>
          <v-img src="@/assets/avatar.png"></v-img>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title>{{$store.operador.nombre}}</v-list-item-title>
          <v-list-item-subtitle>{{$store.operador.rol}}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list dense>
        <span v-for="(elemento, i) in elementosMenuOperador" :key="elemento.titulo">
          <v-divider v-if="i>0 && elementosMenuOperador[i-1].seccion != elementosMenuOperador[i].seccion" class="my-2" />

          <v-list-group v-if="elemento.menu">
            <template v-slot:activator>
              <v-list-item-icon class="mr-3">
                <v-icon>{{ elemento.icono }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ elemento.titulo }}</v-list-item-title>
              </v-list-item-content>
            </template>

            <span v-for="(subelemento, j) in elemento.elementos" :key="subelemento.titulo">
              <v-divider v-if="j>0 && elemento.elementos[j-1].seccion != elemento.elementos[j].seccion" class="my-2" />

              <v-list-item link :to="subelemento.ruta" class="ml-4">
                <v-list-item-icon class="mr-3">
                  <v-icon>{{ subelemento.icono }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ subelemento.titulo }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </span>
          </v-list-group>

          <v-list-item v-else link :to="elemento.ruta">
            <v-list-item-icon class="mr-3">
              <v-icon>{{ elemento.icono }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-badge
                :content="elemento.notificaciones"
                :value="elemento.notificaciones > 0"
                inline>
                <v-list-item-title>{{ elemento.titulo }}</v-list-item-title>
              </v-badge>
            </v-list-item-content>
          </v-list-item>
        </span>
      </v-list>

      <div style="height: 30px"></div>
    </v-navigation-drawer>

    <!-- app bar -->
    <v-app-bar class="barras-app">
      <v-app-bar-nav-icon @click="menuLateral=!menuLateral"></v-app-bar-nav-icon>
      <!-- <img src="assets/logo.png" style="margin-top: 5px; margin-left: 5px; max-height: 40px" /> -->
      <div class="logo-cliente-barra-app" style="height: 40px"></div>

      <!-- <v-spacer></v-spacer> -->
      <div style="width: 1px; height: 50px; background-color: #999; margin-left: 3px; margin-right: 16px"></div>
      <v-toolbar-title>
        <router-link style="text-decoration: none; color: inherit" to="/panel">
           <div class="titulo-app mt-2">
            <!-- <img src="@/assets/autoriza.png" style="margin-right: 6px; max-height: 50px; vertical-align: middle; transform: translate(0, -4px);" /> -->
            <span style="font-family: Monospace; letter-spacing: -0.2px; font-size: 24px; font-weight: bold;">{{ env.VUE_APP_TITULO ? env.VUE_APP_TITULO : $parametros_configuracion.nomcomcli }}
              <span v-if="$parametros_configuracion.indinsdes" style="font-family: courier new; font-size: 16px; color: red">(dev)</span>
            </span>
          </div>
        </router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>

      <template v-if="arrayFiltroInstalaciones.length > 2">
        <v-select
          :items="arrayFiltroInstalaciones"
          item-text="nom"
          item-value="id_ins"
          v-model="$store.datos.id_instalacion_seleccionada"
          :class="[{ 'fondo-amarillo': $store.datos.id_instalacion_seleccionada }, 'select-instalacion']"
          prepend-inner-icon="mdi-file-powerpoint-box"
          hide-details
          dense
          @change="changeFiltroInstalacion">
        </v-select>
      </template>

      <!-- <div v-else v-show="$vuetify.breakpoint.mdAndUp && menuLateral" style="width: 16%; height: 5px;"></div> -->

      <template v-if="permitirConmutarModoPantalla">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon @click="conmutarModoPantalla" v-bind="attrs" v-on="on">
              <v-icon v-if="!$global.enModoPantallaCompleta">mdi-fullscreen</v-icon>
              <v-icon v-else>mdi-fullscreen-exit</v-icon>
            </v-btn>
          </template>
          {{ $t ('Modo pantalla completa') }}
        </v-tooltip>
      </template>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon style="margin-right: 5px" v-bind="attrs" v-on="on" @click="cerrarSesion">
            <v-icon>mdi-logout-variant</v-icon>
          </v-btn>
        </template>
        {{ $t ('Cerrar sesión') }}
      </v-tooltip>
    </v-app-bar>

    <!-- router view -->

    <v-scroll-x-transition hide-on-leave>
      <router-view :key="claveRouterView" />
    </v-scroll-x-transition>

    <div style="height: 65px"></div>

    <!-- pie de la vista -->

    <v-footer absolute padless tile class="barras-app" style="opacity: 0.7">
      <v-container class="text-center pa-1">
        {{ new Date().getFullYear() }} —
        <strong>EQUINSA Parking</strong>
        <span class="caption"> - v{{version}}</span>
      </v-container>
    </v-footer>

  </v-main>
</template>

<script>
import menu from '@/menu.js';
import api from "@/api"
import screenfull from 'screenfull';

export default {
  components: { },
  data: () => ({
    version: process.env.VUE_APP_VERSION,
    menuLateral: true,
    elementosMenuOperador: [],
    claveRouterView: 0,
  }),
  computed: {
    env () {
      return process.env;
    },
    arrayFiltroInstalaciones() {
      let array = (this.$tablasConsulta.arrayRegistros ('ins') || []).filter ((e) => !e.ocultar);
      array.sort ((a,b) => a.nom.localeCompare (b.nom));
      array.unshift ({id_ins: null, nom: this.$t ('(Vista global)') });
      return array;
    },
    permitirConmutarModoPantalla() {
      return screenfull.isEnabled;
    }
  },
  methods: {
    changeFiltroInstalacion (){
      api.guardarDatosSesion ( { id_instalacion_seleccionada: this.$store.datos.id_instalacion_seleccionada })
        .then (() => {
          this.$tablasConsulta.invalidar();
          this.$tablasConsulta.actualizar()
            .then  (() => {
              this.claveRouterView = Math.round (Math.random ()*99999);
            });
        });
    },
    conmutarModoPantalla (){
      if (screenfull.isEnabled)
        screenfull.toggle();
    },
    cerrarSesion() {
      this.$store.CERRAR_SESION()
        .then (() => {
          window.location.replace(process.env.VUE_APP_URL_BASE_FRONTEND);
        });
    }
  },
  created() {
    // traducimos las opciones del menú
    menu.aplicarTraducciones();

    // actualizamos las tablas de consulta
    this.$tablasConsulta.actualizar();
  },
  beforeMount () {
    this.elementosMenuOperador = menu.arbolOpcionesMenu();
  },
  destroyed() {
  }
};
</script>

<style>
.destacar {
  color: aquamarine;
  font-size: 16px;
  font-weight: bold;
}
.select-instalacion {
  margin-left: 10px;
  padding: 4px !important;
  font-size: 14px;
  font-weight: 800;
  max-width: 250px;
}
.fondo-amarillo {
  background-color: #FFF59D;
}
</style>
